import { render, staticRenderFns } from "./ExpulsionCarModel.vue?vue&type=template&id=bc9e55e0&scoped=true"
import script from "./ExpulsionCarModel.vue?vue&type=script&lang=js"
export * from "./ExpulsionCarModel.vue?vue&type=script&lang=js"
import style0 from "./ExpulsionCarModel.vue?vue&type=style&index=0&id=bc9e55e0&prod&lang=css"
import style1 from "./ExpulsionCarModel.vue?vue&type=style&index=1&id=bc9e55e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e55e0",
  null
  
)

export default component.exports